import type { ConversationIcon } from "../../utils/InboxHelper";
import userLineSvg from "../../../assets/user-line.svg";
import usersLineSvg from "../../../assets/users-line.svg";

interface SvgAvatarProps {
  /** "single" = one-to-one icon, "multiple" = group icon */
  icon?: ConversationIcon;
  /** Container size — matches ConversationList (large) and ChatHeader (medium) */
  size?: "medium" | "large";
}

const SIZES: Record<NonNullable<SvgAvatarProps["size"]>, { container: string; icon: number }> = {
  medium: { container: "lds-w-14 lds-h-14", icon: 22 },
  large: { container: "lds-w-16 lds-h-16", icon: 28 },
};

/**
 * Grey circle avatar with a centred SVG icon.
 * Mirrors mobile BatchedProfileImage — user-line for 1:1, users-line for group.
 */
const SvgAvatar = ({ icon = "single", size = "large" }: SvgAvatarProps) => {
  const src = icon === "multiple" ? usersLineSvg : userLineSvg;
  const { container, icon: iconSize } = SIZES[size];
  return (
    <div
      className={`${container} lds-rounded-full lds-bg-surface-strong lds-flex lds-items-center lds-justify-center lds-shrink-0`}
    >
      <img src={src} width={iconSize} height={iconSize} alt="" aria-hidden="true" />
    </div>
  );
};

export default SvgAvatar;
